module.exports = __webpack_public_path__ + "img/taketomi_14.4a2d7b11.jpg";